export const ACTIVITY_VIEWS = {
    RECENT_ACTIVITY: 'recent-activity',
    NEW_ACTIVITY_OPTIONS: 'new-activity-options',
    SITE_VISIT_DONE: 'site-visit-done',
    BOOKING_DONE: 'booking-done',
    EOI_DONE: 'EOI-done',
    CUSTOM_ACTIVITY: 'custom-activity'
}